import { RequestType, RequestChangeType } from '@shared/requests/types'

// This is supposed to be deprecated with time
// and replaced with `RequestType` enum
const REQUEST_TYPES = {
  // Curriculum Requests Types
  newCourse: RequestType.newCourse,
  editCourse: RequestType.editCourse,
  deleteCourse: RequestType.deleteCourse,
  newProgram: RequestType.newProgram,
  editProgram: RequestType.editProgram,
  deleteProgram: RequestType.deleteProgram,

  // Event Request Types
  newEvent: RequestType.newEvent,
  editEvent: RequestType.editEvent,

  // Catalog Request Types
  newCatalogPage: RequestType.newCatalogPage,
  editCatalogPage: RequestType.editCatalogPage,
  deleteCatalogPage: RequestType.deleteCatalogPage,

  // Scheduling Request Types
  // This will be `request.type`
  ruleException: RequestType.ruleException,
  sectionChange: RequestType.sectionChange,
  scheduleValidation: RequestType.scheduleValidation,
}

// This will be `request.request.changeType`
// and it's ONLY for 'sectionChange' request types!
const REQUEST_CHANGE_TYPES = {
  addSection: RequestChangeType.ADD_SECTION,
  editSection: RequestChangeType.EDIT_SECTION,
  deleteSection: RequestChangeType.DELETE_SECTION,
  addSectionFromCourseInventory: RequestChangeType.ADD_SECTION_FROM_COURSE_INVENTORY,
}

const SYSTEM_DOCUMENT_TYPES_MAP = {
  cm: [
    {
      name: 'Course',
      id: 'course',
      requestTypes: [
        {
          name: 'New Course',
          id: REQUEST_TYPES.newCourse,

        },
        {
          name: 'Edit Course',
          id: REQUEST_TYPES.editCourse,
        },
        {
          name: 'Delete Course',
          id: REQUEST_TYPES.deleteCourse,
        },
      ],
    },
    {
      name: 'Program',
      id: 'program',
      requestTypes: [
        {
          name: 'New Program',
          id: REQUEST_TYPES.newProgram,
        },
        {
          name: 'Edit Program',
          id: REQUEST_TYPES.editProgram,
        },
        {
          name: 'Delete Program',
          id: REQUEST_TYPES.deleteProgram,
        },
      ],
    },
  ],
  ca: [
    {
      name: 'Catalog Page',
      id: 'catalogPage',
      requestTypes: [
        { name: 'New Catalog Page', id: REQUEST_TYPES.newCatalogPage },
        { name: 'Edit Catalog Page', id: REQUEST_TYPES.editCatalogPage },
        { name: 'Delete Catalog Page', id: REQUEST_TYPES.deleteCatalogPage },
      ],
    },
  ],
  em: [
    {
      name: 'Event',
      id: 'event',
      requestTypes: [
        { name: 'New Event', id: REQUEST_TYPES.newEvent },
        { name: 'Edit Event', id: REQUEST_TYPES.editEvent },
      ],
    },
  ],
  sm: [
    {
      name: 'Rule',
      id: 'rule',
      requestTypes: [ { name: 'Rule Exception', id: REQUEST_TYPES.ruleException } ],
    },
    {
      name: 'Section',
      id: 'section',
      requestTypes: [ { name: 'Section Change', id: REQUEST_TYPES.sectionChange } ],
    },
    {
      name: 'Schedule Validation',
      // This is the same as `SCHEDULE_VALIDATION`,
      // but semantically these are two different things.
      // TODO: Check what this `id` is used for in the end
      id: 'scheduleValidation',
      requestTypes: [ { name: 'Schedule Validation', id: REQUEST_TYPES.scheduleValidation, disableCreateInUi: true } ],
    },
  ],
}

// This function returns the array of all request types.
// While simple, this function is here to ensure no one makes the mistake
// of trying to generate requestTypesList using Object.keys(REQUEST_TYPES)
function getRequestTypesList () {
  return Object.values(REQUEST_TYPES)
}

function getProductRequestTypes (product) {
  if (!product) return []
  const productEntities = SYSTEM_DOCUMENT_TYPES_MAP[product] || []
  return productEntities.reduce((array, entity) => {
    const requestTypes = (entity.requestTypes || []).map(el => el.id)
    array.push(...requestTypes)
    return array
  }, [])
}

function getProductFromRequestType (requestType) {

  let res = 'cm'
  Object.keys(SYSTEM_DOCUMENT_TYPES_MAP).forEach(product => {
    const requestTypes = getProductRequestTypes(product)
    if (requestTypes.includes(requestType)) res = product
  })
  // default is to return CM because CM contains "documentType" requestTypes
  // that do NOT map to a pre-built request type
  return res
}

module.exports = {
  SYSTEM_DOCUMENT_TYPES_MAP,
  REQUEST_TYPES,
  REQUEST_CHANGE_TYPES,
  getRequestTypesList,
  getProductRequestTypes,
  getProductFromRequestType,
}
